/**
 * Sum values
 * See https://www.delftstack.com/howto/javascript/javascript-sum-of-array/#use-the-reduce-method-to-sum-an-array-in-a-javascript-array
 * @param arr
 * @returns {*}
 */
export const sumValues = (arr = []) => {
  if (!arr.length) return 0
  const reducer = (accumulator, curr) => accumulator + curr
  return arr.reduce(reducer)
}

/**
 * Calculate time on milliseconds duration
 * See https://www.codegrepper.com/code-examples/javascript/get+time+in+milliseconds+javascript
 * @param duration
 * @returns {string}
 */
export const millisecondsToTime = (duration) => {
  const milliseconds = parseInt((duration % 1000) / 100)
  let seconds = Math.floor((duration / 1000) % 60)
  let minutes = Math.floor((duration / (1000 * 60)) % 60)
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds

  return hours + ':' + minutes + ':' + seconds + '.' + milliseconds
}

export const secondsToTime = (duration) => {
  // https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
  const date = new Date(0)
  date.setSeconds(parseInt(duration))
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  // See https://bobbyhadz.com/blog/javascript-pad-number-with-leading-zeros
  return {
    seconds: String(seconds).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    hours: String(hours).padStart(2, '0')
  }
}

/**
 * Calculate match totals duration
 *
 * @param data
 */
export const calculateMatchesTotal = (data) => {
  const duration = data.map((o) => {
    const { matchEndedTime, matchStartedTime } = o
    return new Date(matchEndedTime) - new Date(matchStartedTime)
  })

  const total = sumValues(duration)

  return {
    time: millisecondsToTime(total),
    // Rounding
    // See https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
    hours: Math.round((total / 3600000) * 100) / 100,
    minutes: total / 60000,
    seconds: total / 1000,
    miliseconds: total
  }
}

/**
 * Converts the array from Match State players into a recognizable array for Craft CMS GraphQL mutation
 * @param data
 * @returns {*[]}
 */
export const convertLineUpForMutation = (data, visible) => {
  const array = []
  data.forEach((o, i) => {
    array[i] = {
      col1: o.uuid,
      col2: o.name
    }
    if (Object.keys(o).length >= 3) {
      array[i].col3 = o.playingTime ? (visible ? Math.round(parseInt(o.playingTime) / 60) : o.playingTime) : 0
    }
  })

  return array
}
export const convertLogsForMutation = (data) => {
  const array = []
  data.forEach((o, i) => {
    array[i] = {
      col1: o.type,
      col2: o.note,
      col3: o.date
    }
  })

  return array
}

export const updateOrInsertLogNotes = (array, element) => {
  if (!array.length) {
    array.push(element)
  } else {
    const i = array.findIndex((_element) => _element.note.split(':')[0] === element.note.split(':')[0])
    if (i > -1) {
      array[i] = element
    } else {
      array.push(element)
    }
  }
  return array
}
